import {
  PropsWithChildren, StrictMode,
} from 'react';
import ReactGA from 'react-ga4';
import { AzureProvider, UserProvider, SessionProvider } from '../../authentication';
import { Theme } from '../../styling';
import { SidebarProvider } from '../Sidebar';
import { RefsProvider } from '../Refs';
import { ToastNotificationProvider } from '../Notifications';
import { LoaderProvider } from '../Loader';
import { ModalProvider } from '../Modal';
import { combineComponents } from '../../util';

const providers = [
  AzureProvider,
  UserProvider,
  SessionProvider,
  RefsProvider,
  SidebarProvider,
  Theme,
  ToastNotificationProvider,
  LoaderProvider,
  ModalProvider,
];

const AppContextProvider = combineComponents(...providers);

export function AppWrapper({ children }: PropsWithChildren) {
  ReactGA.initialize([{ trackingId: `${process.env.REACT_APP_GA}` }]);

  return (
    <StrictMode>
      <AppContextProvider>{children}</AppContextProvider>
    </StrictMode>
  );
}
